// @ts-ignore
import React from "react";
import {Box, BoxProps} from "@chakra-ui/react";

export const ContentCard: React.FC<BoxProps> = ({children, ...props}) => {
    return (
        <Box
            bg="white"
            borderWidth="1px"
            borderColor="gray.200"
            borderRadius="2xl"
            p={{ base: 6, md: 8 }}
            boxShadow="sm"
            {...props}
            maxW="100%"
        >
            {children}
        </Box>
    );
};